export const HOLD_LEVEL = {
  1: 'var(--boogie-blast)',
  2: 'var(--fennel-flower)',
  3: 'var(--butternut)'
};
